import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Hero from '../components/payup/Hero';
import TrustedCountries from '../components/payup/TrustedCountries';
import Solutions from '../components/payup/Solutions';
import SecuritySection from '../components/payup/SecuritySection';
import Features from '../components/payup/Features';
import Transactions from '../components/payup/Transactions';
import Blog from '../components/payup/Blog';
import FAQ from '../components/payup/FAQ';
import Footer from '../components/payup/Footer';

const PayupPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white relative">
      {/* Floating Back Button - offset to avoid WhatsApp button overlap */}
      <button
        onClick={() => navigate('/portfolio')}
        className="fixed bottom-24 right-8 z-[100] bg-slate-900 text-white px-6 py-3 rounded-full font-bold shadow-2xl hover:scale-105 active:scale-95 transition-all flex items-center gap-2 border border-white/10"
      >
        <FiArrowLeft className="w-5 h-5" />
        <span>Head back to hostfig.com</span>
      </button>

      <main>
        <Hero />
        <TrustedCountries />
        <Solutions />
        <SecuritySection />
        <Features />
        <Transactions />
        <Blog />
        <FAQ />
        <Footer />
      </main>
    </div>
  );
};

export default PayupPage;